import type React from 'react';

import { Carousel } from '@change-corgi/design-system-legacy/components/content';
import { Flex } from '@change-corgi/design-system-legacy/layout';

import { Waypoint } from 'src/app/shared/components/scroll';

import { useDashboardReskinExperiment } from '../../../../hooks/useDashboardReskinExperiment';

import { AutoTaggedPetition } from './components/AutoTaggedPetition';
import { DecisionMakerRecommendation } from './components/DecisionMakerRecommendation';
import { EmailDecisionMaker } from './components/EmailDecisionMaker';
import { FreePromotionFulfillment } from './components/FreePromotionFulfillment';
import { NOTIFICATION_TYPES } from './constants';
import { useNotificationsCenter } from './hooks/useNotificationsCenter';
import { NotificationsCenter as NotificationsCenterReskin } from './index_new';

export const NotificationsCenter: React.FC = () => {
	const { data, actions } = useNotificationsCenter();

	const {
		data: { isEnabled },
	} = useDashboardReskinExperiment();

	if (isEnabled) {
		return <NotificationsCenterReskin />;
	}

	return (
		<Carousel
			color="primary-white"
			marginBottom={16}
			sx={{
				'#carousel-items > *': {
					backgroundColor: 'secondary-purple',
				},
				'& > #carousel-dots': {
					display: 'none',
				},
			}}
		>
			{data.notifications.map((notification) => {
				switch (notification.type) {
					case NOTIFICATION_TYPES.freePromotionFulfillment:
						return (
							<Flex key="free-promotion-fulfillment">
								<FreePromotionFulfillment />
								<Waypoint horizontal onEnter={() => actions.trackNotificationView(notification.type)} />
							</Flex>
						);
					case NOTIFICATION_TYPES.decisionMakerRecommendation:
						return (
							<Flex key="dm-recommendation">
								<DecisionMakerRecommendation />
								<Waypoint horizontal onEnter={() => actions.trackNotificationView(notification.type)} />
							</Flex>
						);
					case NOTIFICATION_TYPES.autoTaggedPetition:
						return (
							<Flex key="auto-tagged">
								<AutoTaggedPetition />
								<Waypoint horizontal onEnter={() => actions.trackNotificationView(notification.type)} />
							</Flex>
						);

					case NOTIFICATION_TYPES.emailDecisionMaker:
						return (
							<Flex key="starter-can-email-dm">
								<EmailDecisionMaker />
								<Waypoint horizontal onEnter={() => actions.trackNotificationView(notification.type)} />
							</Flex>
						);
					default:
						return null;
				}
			})}
		</Carousel>
	);
};
